(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairBoothTypesController', PhysicalFairBoothTypesController);
    PhysicalFairBoothTypesController.$inject = ['ExpoService', 'PhysicalFairService'];
    function PhysicalFairBoothTypesController(ExpoService, PhysicalFairService) {
        var vm = this;

        vm.flag                  = false;
        vm.expoSelected          = '';
        vm.citySelected          = '';
        vm.typeSelected          = '';
        vm.selectExpo            = selectExpo;
        vm.selectCities          = selectCities;
        vm.selectBoothType       = selectBoothType;
        vm.getByFilter           = getByFilter;
        vm.changeExpo            = changeExpo;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function activate() {
            vm.selectExpo();
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                 vm.expos = response.data;
            }).catch(function(err) {
            });
        }

        function selectBoothType () {
            vm.query = {};
            vm.query['expo_location_id'] = vm.citySelected;
            ExpoService.getBoothTypesForSelect(vm.query).then(function(response){
                vm.boothTypes = response.data;
            });
        }

        function selectCities () {
            vm.query = {};
            vm.query['expos_ids'] = vm.expoSelected;
            ExpoService.getExposCities(vm.query).then(function(response){
                vm.cities = response.data;
            });
        }

        function getByFilter() {

            vm.queryFlag = false;
            vm.query = {};
            vm.query['page']    = vm.page;
            if(vm.expoSelected !== '') {
                vm.query['expo_id'] = vm.expoSelected;
            }
            if(vm.citySelected !== '') {
                vm.query['expo_location_id'] = vm.citySelected;
            }
            if(vm.typeSelected !== '') {
                vm.query['type_id'] = vm.typeSelected;
            }
            PhysicalFairService.getBoothTypes(vm.query).then(function(response){
                vm.queryFlag        = true;
                vm.exhibitors       = response.data.data;
                vm.totalItems       = response.data.total;
                vm.itemsPerPage     = response.data.per_page;
                vm.setPage(response.data.current_page);

            }).catch(function(err){
            });
        }

        function changeExpo() {
            vm.citySelected = '';
            vm.typeSelected = '';
            vm.cities       = [];
            vm.boothTypes   = [];
            vm.selectCities();
        }
        activate();
    }
})();